import React from 'react';

import { Resource } from '../../../../common/constants/resource';
import { License, MVRLicenseInfo } from '../../../tasks/types/mvr';
import styles from './mvr.module.scss';

const renderStatus = (status?: string) => {
  if (!status) {
    return Resource.NORA_M_DASH;
  }
  const isValid = status.toUpperCase().includes('VALID');
  const className = isValid
    ? `${styles.statusPill} ${styles.valid}`
    : styles.statusPill;
  return <span className={className}>{status.toUpperCase()}</span>;
};

const renderLicenseBar = (
  license: License,
  licenseNumber: string,
  key: number,
) => (
  <div className={styles.infoBar} key={key}>
    <div className={styles.infoField}>
      <div className={styles.fieldLabel}>{Resource.MVR_LICENSE_NUMBER}</div>
      <div className={`${styles.fieldValue} ${styles.mono}`}>
        {licenseNumber || Resource.NORA_M_DASH}
      </div>
    </div>
    <div className={styles.infoField}>
      <div className={styles.fieldLabel}>
        {Resource.MVR_LICENSE_STATE_LABEL}
      </div>
      <div className={styles.fieldValue}>
        {license.state || Resource.NORA_M_DASH}
      </div>
    </div>
    <div className={styles.infoField}>
      <div className={styles.fieldLabel}>{Resource.MVR_LICENSE_CLASS}</div>
      <div className={styles.fieldValue}>
        {license.licenseClass || Resource.NORA_M_DASH}
      </div>
    </div>
    <div className={styles.infoField}>
      <div className={styles.fieldLabel}>{Resource.MVR_LICENSE_ISSUED}</div>
      <div className={styles.fieldValue}>
        {license.issueDate || Resource.NORA_M_DASH}
      </div>
    </div>
    <div className={styles.infoField}>
      <div className={styles.fieldLabel}>{Resource.MVR_LICENSE_EXPIRES}</div>
      <div className={styles.fieldValue}>
        {license.expiryDate || Resource.NORA_M_DASH}
      </div>
    </div>
    <div className={styles.infoField}>
      <div className={styles.fieldLabel}>{Resource.MVR_LICENSE_STATUS}</div>
      <div className={styles.fieldValue}>{renderStatus(license.status)}</div>
    </div>
    {license.restriction && (
      <div className={styles.infoField}>
        <div className={styles.fieldLabel}>
          {Resource.MVR_LICENSE_RESTRICTIONS}
        </div>
        <div className={styles.fieldValue}>{license.restriction}</div>
      </div>
    )}
  </div>
);

/** Redesigned license section: one mock "info-bar" per license on file. */
export const MVRLicenseInfoBars = ({
  licenseInfo,
}: {
  licenseInfo: MVRLicenseInfo;
}) => {
  if (!licenseInfo.licenseNumber && licenseInfo.licenses.length === 0) {
    return <></>;
  }
  return (
    <>
      {licenseInfo.licenses.map((license, idx) =>
        renderLicenseBar(license, licenseInfo.licenseNumber, idx),
      )}
    </>
  );
};
